<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-10 19:56:31
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-01 14:30:28
-->
<template>
	<div>
		<div v-if="row.hasSku">
			<span class="flex-row-align-center" v-if="row.specification">
				<el-image style="width: 28px; height: 28px; border-radius: 4px" class="mr-8" :src="row.imageUrl">
					<template v-slot:error>
						<img src="@/assets/public/img-empty1.png" alt="" />
					</template>
				</el-image>
				<Explain :content="row.specification" :disabled="row.specification.length <= 9" :showIcon="false">
					<el-tag type="info" effect="plain" size="small" closable @close="deleteSku(row.productId, row.id)">
						{{ row.specification | textFormat(9) }}
					</el-tag>
				</Explain>
			</span>
			<span v-else class="yx-color-text-secondary">
				未选择
			</span>
		</div>
		<div class="yx-color-warning font-h6-regular" v-else>
			<i class="el-icon-warning"></i>
			<span class="ml-4">未获取到规格</span>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	inject: ['deleteSku'],
	data() {
		return {};
	},
	components: {
		Explain: () => import('@/components/common/explain'),
	},
};
</script>
